import {UserRead, UserTier} from "../schemas";
import {apiFetch} from "./client";

/** Human labels for the backend tiers. Limits themselves come from the usage endpoints. */
export const TIER_LABELS: Record<UserTier, string> = {
    [UserTier.FREE]: "Free",
    [UserTier.PARTNER]: "Partner",
    [UserTier.UNLIMITED]: "Unlimited",
};

export async function fetchOrStoreUser(user?: UserRead): Promise<UserRead> {
    if (user) {
        localStorage.setItem("user", JSON.stringify(user));
        return user;
    }
    const fetched = await apiFetch<UserRead>("/auth/me");
    localStorage.setItem("user", JSON.stringify(fetched));
    return fetched;
}

export async function completeUserTutorial(): Promise<UserRead> {
    return apiFetch<UserRead>("/users/complete_user_tutorial", {method: "POST"});
}

export type UserUploadPageUsage = {
    pages_today: number;
    daily_limit: number | null;
    pages_lifetime: number;
    lifetime_limit: number | null;
    is_over_limit: boolean;
    resets_at: string;
};

export async function getUploadPageUsage(): Promise<UserUploadPageUsage> {
    return apiFetch<UserUploadPageUsage>("/users/upload_page_usage");
}

export type UserLlmUsage = {
    tokens_used_today: number;
    tier_limit: number;
    is_over_limit: boolean;
    resets_at: string;
};

export async function getLlmUsage(): Promise<UserLlmUsage> {
    return apiFetch<UserLlmUsage>("/users/llm_usage");
}

/** Permanently delete the current user's account and the workspaces they own. */
export async function deleteAccount(): Promise<void> {
    await apiFetch<void>("/users/me", {method: "DELETE"});
}
